import AccountUnderReviewWidget from './AccountUnderReviewWidget';

export default AccountUnderReviewWidget;
